import { render, staticRenderFns } from "./PartsControlRecieveParts.vue?vue&type=template&id=0f8fe0d8&scoped=true"
import script from "./PartsControlRecieveParts.vue?vue&type=script&lang=js"
export * from "./PartsControlRecieveParts.vue?vue&type=script&lang=js"
import style0 from "./PartsControlRecieveParts.vue?vue&type=style&index=0&id=0f8fe0d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fe0d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8fe0d8')) {
      api.createRecord('0f8fe0d8', component.options)
    } else {
      api.reload('0f8fe0d8', component.options)
    }
    module.hot.accept("./PartsControlRecieveParts.vue?vue&type=template&id=0f8fe0d8&scoped=true", function () {
      api.rerender('0f8fe0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/partsControl/orderControlScreens/receiveParts/PartsControlRecieveParts.vue"
export default component.exports